/* eslint-disable prettier/prettier */
import React from 'react';

const RequiredAsterisk = () => <p className="ml-1 inline text-error">*</p>;

export default RequiredAsterisk;
